<template>
  <div class="company">
    <div class="header">
      <div class="avatar">
        <img src="@/assets/tupian.png" alt>
      </div>
      <div class="detail">
        <h4>新疆鸿博泰达商贸有限公司</h4>
        <span class="entry-time">入驻时间：2019-1-24</span>
        <p>
          联系人：
          <span>周润发</span>
          联系电话：
          <span>15888888888</span>
          企业所在地：
          <span>新疆乌鲁木齐高新技术产业开发区（新市区）北京南路439号中核大厦14层</span>
        </p>
      </div>
    </div>
    <div class="top-tab">
      <ul>
        <li>企业信息</li>
        <li>工程材料</li>
        <li class="active">工程工队</li>
        <li>招采信息</li>
        <li>工程机械</li>
        <li>工程设备</li>
      </ul>
    </div>
    <div class="my-table">
      <div class="second-tab">
        <ul>
          <li :class="{'active': active === 'Performance'}" @click="active = 'Performance'">工程业绩</li>
          <li :class="{'active': active === 'Device'}" @click="active = 'Device'">专业设备</li>
          <li :class="{'active': active === 'Talent'}" @click="active = 'Talent'">专业人才</li>
          <li :class="{'active': active === 'Team'}" @click="active = 'Team'">管理团队</li>
        </ul>
      </div>
      <Performance v-show="active === 'Performance'"></Performance>
      <Device v-show="active === 'Device'"></Device>
      <Talent v-show="active === 'Talent'"></Talent>
      <Team v-show="active === 'Team'"></Team>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    Performance: () => import('@/views/companyDetail/components/Performance'),
    Device: () => import('@/views/companyDetail/components/device'),
    Talent: () => import('@/views/companyDetail/components/talent'),
    Team: () => import('@/views/companyDetail/components/team')
  },
  data () {
    return {
      active: 'Performance'
    }
  },
  methods: {
    handleClick (tab, event) {
      //
    }
  }
}
</script>
<style lang="scss" scoped>
.company {
  width: 1200px;
  margin: 20px auto;
  .header {
    display: flex;
    background-color: #fff;
    .avatar {
      width: 120px;
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 90px;
        height: 90px;
      }
    }
    .detail {
      flex: 1;
      padding: 20px 20px 20px 0;
      h4 {
        font-size: 24px;
        font-weight: normal;
      }
      .entry-time {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #969696;
      }
      p {
        font-size: 14px;
        color: #666;
        word-wrap: break-word;
        word-break: break-all;
        span {
          // display: inline-block;
          margin-right: 40px;
          color: #000;
          word-wrap: break-word;
          word-break: break-all;
        }
      }
    }
  }
  .top-tab {
    margin-top: 35px;
    margin-bottom: 10px;
    ul {
      background-color: #fff;
      width: 670px;
      padding: 8px 0;
      border-radius: 4px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      li {
        float: left;
        width: 110px;
        color: #000;
        font-size: 16px;
        text-align: center;
        height: 25px;
        line-height: 25px;
        border-left: 2px solid #dfe4ea;
        cursor: pointer;
        &:first-child {
          border: none;
        }
      }
      .active {
        color: #0286df;
      }
    }
  }
  .my-table {
    .second-tab {
      ul {
        width: 400px;
        display: flex;
        background-color: #fff;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        li {
          flex: 1;
          border-left: 1px solid #e4e7ed;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 14px;
          color: #333;
          cursor: pointer;
          &:first-child {
            border: none;
          }
        }
        .active {
          color: #0286df;
          position: relative;
          &::after {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            width: 100%;
            bottom: -1px;
            height: 0;
            z-index: 1;
            border-bottom: 1px solid #fff;
          }
        }
      }
    }
  }
}
</style>
